import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { Button, type ButtonSizes } from '@xing-com/button';
import { mediaTopBarHidden, mediaTopBarVisible } from '@xing-com/layout-tokens';

const pickMediaQuery = ({ size }: { size: ButtonSizes }): string => {
  return size === 'small' ? mediaTopBarHidden : mediaTopBarVisible;
};

export const StyledButtonSmallWhenTopBar = styled(Button)<{
  size: ButtonSizes;
}>`
  @media ${pickMediaQuery} {
    display: none;
  }
`;

export const CreateJobButton: React.FC = () => {
  const { formatMessage } = useIntl();
  const commonProps = {
    'data-testid': 'styled-create-job-button',
    href: 'https://www.xing.com/recruiting/jobs/create',
    variant: 'primary' as const,
  };

  return (
    <>
      <StyledButtonSmallWhenTopBar {...commonProps} size="small">
        {formatMessage({ id: 'MAINNAV_CREATE_JOB' })}
      </StyledButtonSmallWhenTopBar>
      <StyledButtonSmallWhenTopBar {...commonProps} size="medium">
        {formatMessage({ id: 'MAINNAV_JOBS_EASY_CREATE' })}
      </StyledButtonSmallWhenTopBar>
    </>
  );
};
